export default __webpack_public_path__ + "static/media/LOGO.22ff414c.png";